"use client";
import { createContext, useContext, useState } from "react";

export const BlogContext = createContext({
  blogFilterId: 0,
  setBlogFilterId: (id: number) => {},
});

export const BlogProvider = ({ children }: any) => {
  const [blogFilterId, setBlogFilterId] = useState(0);

  const value = {
    blogFilterId,
    setBlogFilterId,
  };

  return <BlogContext.Provider value={value}>{children}</BlogContext.Provider>;
};

export const useBlogContext = () => {
  return useContext(BlogContext);
};
